export const StoreKeys = {
  ACCESS_TOKEN: '@portal-participe/ACCESS_TOKEN',
  REFRESH_TOKE: '@portal-participe/REFRESH_TOKE',
  CONFERENCE_ACTIVE: '@portal-participe/CONFERENCE_ACTIVE',
  USER_INFO: '@portal-participe/USER_INFO',
  PARTICIPATION_STATE: '@portal-participe/PARTICIPATION_STATE',
  IS_PROFILE_INCOMPLETED: '@portal-participe/IS_PROFILE_COMPLETED',
  LOGOUT_URI: '@portal-participe/LOGOUT_URI',
  PRE_REGISTRATION: '@portal-participe/PRE_REGISTRATION',
  PRE_REGISTRATION_ACTIVE: '@portal-participe/PRE_REGISTRATION_ACTIVE',
  REGISTRATION_ACTIVE: '@portal-participe/REGISTRATION_ACTIVE',
  REDIRECT_URL:'@portal-participe/REDIRECT_URL',
  CHECK_IN: '@portal-participe/CHECK_IN',
  LOGIN_CHECK_IN: '@portal-participe/LOGIN_CHECK_IN',
  CHECK_IN_OFF: '@portal-participe/CHECK_IN_OFF',
  PRE_REGISTRATION_MEETING_STARTED: '@portal-participe/PRE_REGISTRATION_MEETING_STARTED',
  PRE_REGISTRATION_MEETING_CLOSED: '@portal-participe/PRE_REGISTRATION_MEETING_CLOSED'
};

